import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'
import { useNavigate, useParams } from 'react-router-dom'

const employeeData = {
  '1': {
    name: 'Jamie Mitchell', initials: 'JM', id: '#EMP-0014',
    position: 'Operations Coordinator', dept: 'Operations',
    type: 'Full Time', status: 'Active', hire: 'January 12, 2023',
    manager: 'Tiffany Gallagher', email: 'j.mitchell@democompany.co',
    phone: '(207) 555-0142', address: '48 Maple Street, Ellsworth, ME 04605',
    emergency: 'Casey Mitchell', emergencyPhone: '(207) 555-0198',
    attendance: 96, score: 4.2, pto: 11, years: 2.2,
  },
  '2': {
    name: 'Sam Rivera', initials: 'SR', id: '#EMP-0009',
    position: 'Operations Specialist', dept: 'Operations',
    type: 'Full Time', status: 'Active', hire: 'March 3, 2022',
    manager: 'Tiffany Gallagher', email: 's.rivera@democompany.co',
    phone: '(207) 555-0198', address: '22 Pine Street, Bar Harbor, ME 04609',
    emergency: 'Alex Rivera', emergencyPhone: '(207) 555-0211',
    attendance: 92, score: 3.9, pto: 8, years: 3.1,
  },
  '3': {
    name: 'Kim Park', initials: 'KP', id: '#EMP-0007',
    position: 'Administrative Coordinator', dept: 'Administrative',
    type: 'Full Time', status: 'Active', hire: 'June 7, 2021',
    manager: 'Tiffany Gallagher', email: 'k.park@democompany.co',
    phone: '(207) 555-0156', address: '5 Harbor View, Ellsworth, ME 04605',
    emergency: 'Jordan Park', emergencyPhone: '(207) 555-0177',
    attendance: 100, score: 4.6, pto: 14, years: 3.8,
  },
  '4': {
    name: 'Dana Lee', initials: 'DL', id: '#EMP-0016',
    position: 'Field Coordinator', dept: 'Field Staff',
    type: 'Full Time', status: 'Active', hire: 'September 15, 2023',
    manager: 'Tiffany Gallagher', email: 'd.lee@democompany.co',
    phone: '(207) 555-0134', address: '14 Oak Lane, Ellsworth, ME 04605',
    emergency: 'Morgan Lee', emergencyPhone: '(207) 555-0145',
    attendance: 94, score: 4.1, pto: 6, years: 1.5,
  },
  '5': {
    name: 'Marcus Thomas', initials: 'MT', id: '#EMP-0011',
    position: 'Operations Associate', dept: 'Operations',
    type: 'Full Time', status: 'Warning', hire: 'February 20, 2022',
    manager: 'Tiffany Gallagher', email: 'm.thomas@democompany.co',
    phone: '(207) 555-0167', address: '88 Birch Road, Ellsworth, ME 04605',
    emergency: 'Sarah Thomas', emergencyPhone: '(207) 555-0189',
    attendance: 78, score: 2.8, pto: 3, years: 3.1,
  },
  '6': {
    name: 'Jordan Collins', initials: 'JC', id: '#EMP-0018',
    position: 'Field Associate', dept: 'Field Staff',
    type: 'Full Time', status: 'Active', hire: 'November 1, 2023',
    manager: 'Tiffany Gallagher', email: 'j.collins@democompany.co',
    phone: '(207) 555-0123', address: '33 Maple Ave, Bar Harbor, ME 04609',
    emergency: 'Pat Collins', emergencyPhone: '(207) 555-0134',
    attendance: 88, score: 3.5, pto: 5, years: 1.4,
  },
}

export default function EmployeeProfile() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const navigate = useNavigate()
  const { id } = useParams()
  const emp = employeeData[id] || employeeData['1']

  const [activeTab, setActiveTab] = useState('info')
  const [note, setNote] = useState('')
  const [noteType, setNoteType] = useState('General Note')
  const [notes, setNotes] = useState([
    { type: 'Positive Observation', content: 'Strong candidate for team lead role -- track for 6 months', date: 'Dec 15, 2024' },
    { type: 'General Note', content: 'Covered for Sam Rivera on Apr 14 without being asked. Great team attitude.', date: 'Apr 1, 2025' },
  ])
  const [showEdit, setShowEdit] = useState(false)
  const [editData, setEditData] = useState({ ...emp })

  const docs = [
    { title: 'Employee Handbook 2025 -- Signed', meta: 'Signed Jan 12, 2025', status: 'Signed', color: '#4A7C59' },
    { title: 'I-9 Employment Eligibility', meta: 'Completed Jan 12, 2023', status: 'On File', color: '#4A7C59' },
    { title: 'Offer Letter -- Signed', meta: 'Signed Jan 8, 2023', status: 'Signed', color: '#4A7C59' },
    { title: 'Parking Policy Acknowledgment', meta: 'Issued Mar 25, 2025', status: 'Pending', color: '#A0392B' },
  ]

  const history = [
    { title: 'Onboarding completed', detail: 'All 4 steps verified and signed off', date: 'April 2, 2025', color: accent },
    { title: 'Annual performance review', detail: 'Score: 4.2/5.0 - Recommended for raise', date: 'December 15, 2024', color: '#4A7C59' },
    { title: 'Promoted to Operations Coordinator', detail: 'Previous role: Operations Assistant', date: 'July 1, 2024', color: '#4A7C59' },
    { title: '6-month check-in completed', detail: 'Score: 3.8/5.0 - Strong start noted', date: 'July 12, 2023', color: '#4A6B8A' },
    { title: `Hired as ${emp.position}`, detail: `${emp.type} - ${emp.dept} department`, date: emp.hire, color: '#6B7D6B' },
  ]

  function addNote() {
    if (!note.trim()) return
    setNotes(n => [{ type: noteType, content: note, date: 'April 2, 2025' }, ...n])
    setNote('')
  }

  function saveEdit() {
    Object.assign(employeeData[id] || employeeData['1'], editData)
    setShowEdit(false)
  }

  const tabs = ['info', 'performance', 'documents', 'history']
  const inputStyle = { width: '100%', padding: '7px 10px', border: '1px solid #EDE6DA', borderRadius: 6, fontSize: 12, fontFamily: "'Montserrat',sans-serif", outline: 'none', marginBottom: 10, boxSizing: 'border-box' }
  const labelStyle = { fontSize: 9, textTransform: 'uppercase', letterSpacing: '0.1em', color: '#6B7D6B', fontWeight: 600, marginBottom: 3, display: 'block' }

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>

      {/* Edit Profile Modal */}
      {showEdit && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.35)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:560,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 8px 40px rgba(0,0,0,0.18)'}}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:17,fontWeight:600,color:'#2B2B2B'}}>Edit Profile</div>
              <button onClick={()=>setShowEdit(false)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#8A9E8A',lineHeight:1}}>&times;</button>
            </div>
            <div style={{padding:'20px 24px'}}>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'0 16px'}}>
                {[['Full Name','name'],['Email','email'],['Phone','phone'],['Position','position'],['Department','dept'],['Manager','manager'],['Hire Date','hire'],['Emergency Contact','emergency'],['Emergency Phone','emergencyPhone']].map(([label,field])=>(
                  <div key={field} style={{gridColumn: field==='address'||field==='name'?'1/-1':'auto'}}>
                    <label style={labelStyle}>{label}</label>
                    <input value={editData[field]||''} onChange={e=>setEditData(d=>({...d,[field]:e.target.value}))} style={inputStyle} />
                  </div>
                ))}
                <div style={{gridColumn:'1/-1'}}>
                  <label style={labelStyle}>Home Address</label>
                  <input value={editData.address||''} onChange={e=>setEditData(d=>({...d,address:e.target.value}))} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Status</label>
                  <select value={editData.status||'Active'} onChange={e=>setEditData(d=>({...d,status:e.target.value}))} style={inputStyle}>
                    <option>Active</option>
                    <option>Warning</option>
                    <option>Onboarding</option>
                    <option>Inactive</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Employment Type</label>
                  <select value={editData.type||'Full Time'} onChange={e=>setEditData(d=>({...d,type:e.target.value}))} style={inputStyle}>
                    <option>Full Time</option>
                    <option>Part Time</option>
                    <option>Contract</option>
                    <option>Seasonal</option>
                  </select>
                </div>
              </div>
            </div>
            <div style={{padding:'14px 24px',borderTop:'1px solid #EDE6DA',display:'flex',justifyContent:'flex-end',gap:10}}>
              <button onClick={()=>setShowEdit(false)} style={{padding:'8px 18px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Cancel</button>
              <button onClick={saveEdit} style={{padding:'8px 18px',border:'none',borderRadius:6,background:accent,fontSize:12,fontWeight:600,color:'#fff',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Save Changes</button>
            </div>
          </div>
        </div>
      )}

      <div style={{marginBottom:16}}>
        <button onClick={()=>navigate('/admin/employees')} style={{background:'none',border:'none',fontSize:12,color:'#6B7D6B',cursor:'pointer',fontFamily:"'Montserrat',sans-serif",padding:0,display:'flex',alignItems:'center',gap:4}}>
          &larr; All Employees
        </button>
      </div>

      {/* Hero */}
      <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'20px 24px',marginBottom:16,display:'flex',alignItems:'center',gap:20}}>
        <div style={{width:64,height:64,borderRadius:'50%',background:accentBg,border:`2.5px solid ${accent}`,display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'Georgia,serif',fontSize:20,fontWeight:700,color:accent,flexShrink:0}}>
          {emp.initials}
        </div>
        <div style={{flex:1}}>
          <div style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600,marginBottom:4}}>{editData.name}</div>
          <div style={{display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
            <span style={{fontSize:12,color:'#6B7D6B'}}><strong style={{color:'#4A4A4A'}}>{editData.dept}</strong> Department</span>
            <span style={{fontSize:12,color:'#6B7D6B'}}>·</span>
            <span style={{fontSize:12,color:'#6B7D6B'}}><strong style={{color:'#4A4A4A'}}>{editData.type}</strong></span>
            <span style={{fontSize:12,color:'#6B7D6B'}}>·</span>
            <span style={{fontSize:12,color:'#6B7D6B'}}>Hired <strong style={{color:'#4A4A4A'}}>{editData.hire}</strong></span>
            <span style={{fontSize:10,padding:'3px 10px',borderRadius:20,fontWeight:600,background:editData.status==='Active'?'rgba(74,124,89,0.1)':'rgba(160,57,43,0.1)',color:editData.status==='Active'?'#4A7C59':'#A0392B',border:`1px solid ${editData.status==='Active'?'rgba(74,124,89,0.2)':'rgba(160,57,43,0.2)'}`}}>&#9679; {editData.status}</span>
          </div>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10}}>
          {[[emp.years+'y','Tenure'],[emp.attendance+'%','Attendance'],[emp.score+'/5','Perf.'],[emp.pto+'h','PTO Left']].map(([v,l])=>(
            <div key={l} style={{textAlign:'center',background:'#F7F2EB',borderRadius:8,padding:'10px 14px',border:'1px solid #EDE6DA'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:'1.1rem',color:'#2B2B2B',fontWeight:600}}>{v}</div>
              <div style={{fontSize:9,color:'#6B7D6B',textTransform:'uppercase',letterSpacing:'0.08em',marginTop:2}}>{l}</div>
            </div>
          ))}
        </div>
        <div style={{display:'flex',gap:8,flexShrink:0}}>
          <button onClick={()=>navigate('/admin/memos')} style={{padding:'7px 14px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:11,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Send Memo</button>
          <button onClick={()=>setShowEdit(true)} style={{padding:'7px 14px',border:`1px solid ${accent}`,borderRadius:6,background:accent,fontSize:11,fontWeight:600,color:'#fff',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Edit Profile</button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,overflow:'hidden',marginBottom:16}}>
        {tabs.map(t=>(
          <button key={t} onClick={()=>setActiveTab(t)} style={{flex:1,padding:'9px',border:'none',borderRight:'1px solid #EDE6DA',background:activeTab===t?accent:'#fff',color:activeTab===t?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",textTransform:'capitalize',transition:'all 0.15s'}}>
            {t === 'info' ? 'Personal Info' : t === 'history' ? 'History & Notes' : t.charAt(0).toUpperCase()+t.slice(1)}
          </button>
        ))}
      </div>

      {activeTab === 'info' && (
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Contact Information</div>
              <span onClick={()=>setShowEdit(true)} style={{fontSize:11,color:accent,cursor:'pointer'}}>Edit</span>
            </div>
            {[['Full Name',editData.name],['Email',editData.email],['Phone',editData.phone],['Emergency Contact',editData.emergency],['Emergency Phone',editData.emergencyPhone],['Home Address',editData.address]].map(([l,v])=>(
              <div key={l} style={{padding:'10px 16px',borderBottom:'1px solid #EDE6DA'}}>
                <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:2}}>{l}</div>
                <div style={{fontSize:13,color:'#4A4A4A'}}>{v}</div>
              </div>
            ))}
          </div>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Employment Details</div>
              <span onClick={()=>setShowEdit(true)} style={{fontSize:11,color:accent,cursor:'pointer'}}>Edit</span>
            </div>
            {[['Employee ID',editData.id],['Status',editData.status],['Department',editData.dept],['Position',editData.position],['Employment Type',editData.type],['Manager',editData.manager],['Hire Date',editData.hire]].map(([l,v])=>(
              <div key={l} style={{padding:'10px 16px',borderBottom:'1px solid #EDE6DA'}}>
                <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:2}}>{l}</div>
                <div style={{fontSize:13,color:'#4A4A4A'}}>{v}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'performance' && (
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Performance Score</div>
            </div>
            <div style={{padding:'16px',display:'flex',alignItems:'center',gap:16,marginBottom:8}}>
              <div style={{width:64,height:64,borderRadius:'50%',background:accentBg,border:`3px solid ${accent}`,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <div style={{fontFamily:'Georgia,serif',fontSize:18,color:accent,fontWeight:700,lineHeight:1}}>{emp.score}</div>
                <div style={{fontSize:9,color:'#8A9E8A'}}>/5.0</div>
              </div>
              <div>
                <div style={{fontFamily:'Georgia,serif',fontSize:14,color:'#2B2B2B',fontWeight:600}}>{emp.score>=4?'Strong Performer':emp.score>=3?'Meets Expectations':'Needs Improvement'}</div>
                <div style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Last reviewed: December 2024</div>
              </div>
            </div>
            {[['Reliability',5],['Communication',4],['Teamwork',4],['Initiative',4],['Quality of Work',4]].map(([cat,score])=>(
              <div key={cat} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 16px',borderTop:'1px solid #EDE6DA'}}>
                <div style={{fontSize:12,color:'#4A4A4A',width:130,flexShrink:0}}>{cat}</div>
                <div style={{display:'flex',gap:2}}>{[1,2,3,4,5].map(s=><span key={s} style={{color:s<=score?accent:'#EDE6DA',fontSize:14}}>&#9733;</span>)}</div>
                <div style={{flex:1,height:5,background:'#EDE6DA',borderRadius:3,overflow:'hidden'}}>
                  <div style={{height:'100%',width:(score/5*100)+'%',background:accent,borderRadius:3}}></div>
                </div>
              </div>
            ))}
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:14}}>
            <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'16px'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B',marginBottom:12}}>Disciplinary Record</div>
              {emp.status === 'Warning'
                ? <div style={{background:'rgba(160,57,43,0.06)',border:'1px solid rgba(160,57,43,0.15)',borderRadius:8,padding:'12px',fontSize:12,color:'#A0392B'}}>⚠ 3 attendance warnings on file. Formal documentation required.</div>
                : <div style={{textAlign:'center',padding:'16px',color:'#8A9E8A',fontSize:13}}>No warnings or disciplinary actions on file.</div>
              }
            </div>
            <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
              <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA'}}>
                <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Recognition</div>
              </div>
              {[{reason:'Above & beyond -- client event',date:'Apr 1'},{reason:'Team player of the month -- Feb',date:'Feb 28'},{reason:'Perfect attendance -- Q4 2024',date:'Jan 3'}].map((r,i)=>(
                <div key={i} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 16px',borderBottom:'1px solid #EDE6DA'}}>
                  <span style={{color:accent,fontSize:16}}>&#9733;</span>
                  <span style={{flex:1,fontSize:12,color:'#4A4A4A'}}>{r.reason}</span>
                  <span style={{fontSize:11,color:'#8A9E8A'}}>{r.date}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {activeTab === 'documents' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Employee Documents</div>
            <button style={{padding:'6px 14px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>+ Upload</button>
          </div>
          {docs.map((d,i)=>(
            <div key={i} style={{display:'flex',alignItems:'center',gap:14,padding:'14px 16px',borderBottom:i<docs.length-1?'1px solid #EDE6DA':'none'}}>
              <div style={{width:34,height:34,borderRadius:7,background:d.color+'22',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="3" y="2" width="10" height="12" rx="1.5" stroke={d.color} strokeWidth="1.25"/><path d="M5 6h6M5 9h4" stroke={d.color} strokeWidth="1.25" strokeLinecap="round"/></svg>
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:500,color:'#2B2B2B'}}>{d.title}</div>
                <div style={{fontSize:11,color:'#8A9E8A'}}>{d.meta}</div>
              </div>
              <span style={{fontSize:11,fontWeight:600,color:d.color}}>{d.status==='Pending'?'! ':d.status==='Signed'||d.status==='On File'?'✓ ':''}{d.status}</span>
            </div>
          ))}
        </div>
      )}

      {activeTab === 'history' && (
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Employment History</div>
            </div>
            <div style={{padding:'16px',display:'flex',flexDirection:'column',gap:0}}>
              {history.map((h,i)=>(
                <div key={i} style={{display:'flex',gap:12,marginBottom:16,position:'relative'}}>
                  <div style={{width:24,height:24,borderRadius:'50%',background:h.color+'22',border:`2px solid ${h.color}`,flexShrink:0,marginTop:1}}></div>
                  {i<history.length-1 && <div style={{position:'absolute',left:11,top:26,bottom:-16,width:1,background:'#EDE6DA'}}></div>}
                  <div>
                    <div style={{fontSize:12,fontWeight:600,color:'#4A4A4A',marginBottom:2}}>{h.title}</div>
                    <div style={{fontSize:11,color:'#6B7D6B',marginBottom:2}}>{h.detail}</div>
                    <div style={{fontSize:10,color:'#8A9E8A'}}>{h.date}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Admin Notes</div>
              <span style={{fontSize:10,color:'#8A9E8A'}}>Private -- not visible to employee</span>
            </div>
            <div style={{padding:'16px',display:'flex',flexDirection:'column',gap:0}}>
              {notes.map((n,i)=>(
                <div key={i} style={{display:'flex',gap:12,marginBottom:14}}>
                  <div style={{width:20,height:20,borderRadius:'50%',background:accentBg,border:`1.5px solid ${accent}`,flexShrink:0,marginTop:1}}></div>
                  <div>
                    <div style={{fontSize:11,fontWeight:600,color:accent,marginBottom:2}}>{n.type}</div>
                    <div style={{fontSize:12,color:'#4A4A4A',marginBottom:2}}>{n.content}</div>
                    <div style={{fontSize:10,color:'#8A9E8A'}}>{n.date} - T. Gallagher</div>
                  </div>
                </div>
              ))}
            </div>
            <div style={{padding:'14px 16px',borderTop:'1px solid #EDE6DA'}}>
              <textarea value={note} onChange={e=>setNote(e.target.value)} rows={3} placeholder="Add a private admin note..." style={{width:'100%',padding:'8px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',resize:'none',marginBottom:8}}/>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <select value={noteType} onChange={e=>setNoteType(e.target.value)} style={{padding:'6px 10px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:11,fontFamily:"'Montserrat',sans-serif",outline:'none'}}>
                  {['General Note','Performance','Attendance','Positive Observation','Concern'].map(o=><option key={o}>{o}</option>)}
                </select>
                <button onClick={addNote} style={{padding:'6px 16px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Save Note</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
